import {
  SegmentedControlProps as MantineSegmentedControlProps,
  SegmentedControl as MantineSegmentedControl,
} from '@mantine/core';

export type SegmentedControlProps = MantineSegmentedControlProps;

export const SegmentedControl = MantineSegmentedControl;

SegmentedControl.displayName = 'SegmentedControl';
